export enum InferencesRole {
  primary = "primary",
  reference = "reference",
  corpus = "corpus",
}
